import React from 'react';
import { ProfilePage } from '.';
import styles from './ProfileLayout.module.scss';

export const ProfileLayout = ({ isFourOhFour, userData, setUserData }) => (
  <>
    <div className={styles.contentBox}>
      <ProfilePage isFourOhFour={isFourOhFour} userData={userData} setUserData={setUserData} />
    </div>
  </>
);
